// Test IDs for the wholesale Quote Wizard, public Quote/Invoice view pages,
// and the Admin Quotes dashboard.

export const QUOTE_WIZARD = {
  section: 'quote-wizard-section',
  stepIndicator: (n) => `quote-wizard-step-indicator-${n}`,
  buyerNameInput: 'quote-wizard-buyer-name-input',
  companyInput: 'quote-wizard-company-input',
  emailInput: 'quote-wizard-email-input',
  phoneInput: 'quote-wizard-phone-input',
  continueStep1Button: 'quote-wizard-continue-step1-button',
  tireTypeSelect: 'quote-wizard-tire-type-select',
  gradeSelect: 'quote-wizard-grade-select',
  quantityTierButton: (tier) => `quote-wizard-tier-${tier}`,
  customQuantityInput: 'quote-wizard-custom-quantity-input',
  sizeSelect: 'quote-wizard-size-select',
  sizeQuantityInput: 'quote-wizard-size-quantity-input',
  addSizeButton: 'quote-wizard-add-size-button',
  sizeRow: (i) => `quote-wizard-size-row-${i}`,
  removeSizeButton: (i) => `quote-wizard-remove-size-button-${i}`,
  backStep2Button: 'quote-wizard-back-step2-button',
  continueStep2Button: 'quote-wizard-continue-step2-button',
  countryInput: 'quote-wizard-country-input',
  portInput: 'quote-wizard-port-input',
  shippingTermsSelect: 'quote-wizard-shipping-terms-select',
  notesInput: 'quote-wizard-notes-input',
  backStep3Button: 'quote-wizard-back-step3-button',
  continueStep3Button: 'quote-wizard-continue-step3-button',
  backStep4Button: 'quote-wizard-back-step4-button',
  submitButton: 'quote-wizard-submit-button',
  successMessage: 'quote-wizard-success-message',
  resetButton: 'quote-wizard-reset-button',
  honeypot: 'quote-wizard-honeypot-field',
};

export const QUOTE_VIEW_PAGE = {
  section: 'quote-view-page-section',
  downloadPdfButton: 'quote-view-download-pdf-button',
  notFound: 'quote-view-not-found',
};

export const INVOICE_VIEW_PAGE = {
  section: 'invoice-view-page-section',
  downloadPdfButton: 'invoice-view-download-pdf-button',
  notFound: 'invoice-view-not-found',
};

export const ADMIN_QUOTES = {
  page: 'admin-quotes-page',
  navLink: 'admin-quotes-nav-link',
  backToOrdersLink: 'admin-quotes-back-to-orders-link',
  tabQuotes: 'admin-quotes-tab-quotes',
  tabInvoices: 'admin-quotes-tab-invoices',
  searchInput: 'admin-quotes-search-input',
  statusFilterSelect: 'admin-quotes-status-filter-select',
  dueRemindersToggle: 'admin-quotes-due-reminders-toggle',
  table: 'admin-quotes-table',
  row: (qn) => `admin-quotes-row-${qn}`,
  viewButton: (qn) => `admin-quotes-view-button-${qn}`,
  detailDialog: 'admin-quote-detail-dialog',
  notesList: 'admin-quote-notes-list',
  noteInput: 'admin-quote-note-input',
  addNoteButton: 'admin-quote-add-note-button',
  reminderInput: 'admin-quote-reminder-input',
  saveReminderButton: 'admin-quote-save-reminder-button',
  statusSelect: 'admin-quote-status-select',
  pricingSourceInput: 'admin-quote-pricing-source-input',
  pricingUnitPriceInput: 'admin-quote-pricing-unit-price-input',
  pricingCurrencySelect: 'admin-quote-pricing-currency-select',
  pricingFreightIncludedToggle: 'admin-quote-pricing-freight-included-toggle',
  pricingFreightCostInput: 'admin-quote-pricing-freight-cost-input',
  pricingInsuranceCostInput: 'admin-quote-pricing-insurance-cost-input',
  pricingShippingTermsInput: 'admin-quote-pricing-shipping-terms-input',
  pricingDestinationPortInput: 'admin-quote-pricing-destination-port-input',
  pricingExpirationInput: 'admin-quote-pricing-expiration-input',
  pricingPaymentTermsInput: 'admin-quote-pricing-payment-terms-input',
  savePricingButton: 'admin-quote-save-pricing-button',
  liveTotalPreview: 'admin-quote-live-total-preview',
  complianceBanner: 'admin-quote-compliance-banner',
  complianceOverrideCheckbox: 'admin-quote-compliance-override-checkbox',
  sendQuoteButton: 'admin-quote-send-button',
  downloadQuotePdfButton: 'admin-quote-download-pdf-button',
  createInvoiceButton: 'admin-quote-create-invoice-button',
  invoicesTable: 'admin-invoices-table',
  invoiceRow: (inv) => `admin-invoice-row-${inv}`,
  markPaidButton: (inv) => `admin-invoice-mark-paid-button-${inv}`,
  cancelInvoiceButton: (inv) => `admin-invoice-cancel-button-${inv}`,
  paymentReferenceInput: 'admin-invoice-payment-reference-input',
  fulfillmentSelect: (inv) => `admin-invoice-fulfillment-select-${inv}`,
  downloadInvoicePdfButton: (inv) => `admin-invoice-download-pdf-button-${inv}`,

  // Funnel analytics widget
  funnelWidget: 'admin-quotes-funnel-widget',
  funnelBar: (status) => `admin-quotes-funnel-bar-${status.replace(/\s+/g, '-').toLowerCase()}`,

  // Editable sizes
  editSizesButton: 'admin-quote-edit-sizes-button',
  sizesEditDialog: 'admin-quote-sizes-edit-dialog',
  sizesEditSizeSelect: 'admin-quote-sizes-edit-size-select',
  sizesEditQtyInput: 'admin-quote-sizes-edit-qty-input',
  sizesEditAddButton: 'admin-quote-sizes-edit-add-button',
  sizesEditRow: (i) => `admin-quote-sizes-edit-row-${i}`,
  sizesEditRemoveButton: (i) => `admin-quote-sizes-edit-remove-button-${i}`,
  sizesEditTierButton: (tier) => `admin-quote-sizes-edit-tier-${tier}`,
  sizesEditCustomQtyInput: 'admin-quote-sizes-edit-custom-qty-input',
  sizesEditSaveButton: 'admin-quote-sizes-edit-save-button',

  // AI follow-up draft
  aiDraftButton: 'admin-quote-ai-draft-button',
  aiDraftDialog: 'admin-quote-ai-draft-dialog',
  aiDraftSubjectInput: 'admin-quote-ai-draft-subject-input',
  aiDraftBodyInput: 'admin-quote-ai-draft-body-input',
  aiDraftRegenerateButton: 'admin-quote-ai-draft-regenerate-button',
  aiDraftSendButton: 'admin-quote-ai-draft-send-button',
};
